import { create } from 'zustand';
import { loadEncryptedApiKey, saveEncryptedApiKey } from '../utils/apiKeyManager';

interface ApiStore {
  // State
  geminiApiKey: string;
  pixabayApiKey: string;
  
  // Actions
  setGeminiApiKey: (key: string) => void;
  setPixabayApiKey: (key: string) => void;
  loadApiKeys: () => Promise<void>;
  saveApiKeys: () => Promise<void>;
}

export const useApiStore = create<ApiStore>((set, get) => ({
  // Initial state
  geminiApiKey: '',
  pixabayApiKey: '',
  
  // Actions
  setGeminiApiKey: (key) => {
    set({ geminiApiKey: key });
    // Auto-save when API key is updated
    get().saveApiKeys();
  },
  
  setPixabayApiKey: (key) => {
    set({ pixabayApiKey: key });
    // Auto-save when API key is updated
    get().saveApiKeys();
  },
  
  loadApiKeys: async () => {
    try {
      const geminiKey = await loadEncryptedApiKey('gemini');
      const pixabayKey = await loadEncryptedApiKey('pixabay');
      
      set({
        geminiApiKey: geminiKey || '',
        pixabayApiKey: pixabayKey || ''
      });
    } catch (error) {
      console.error('Failed to load API keys:', error);
    }
  },
  
  saveApiKeys: async () => {
    const state = get();
    try {
      if (state.geminiApiKey) {
        await saveEncryptedApiKey(state.geminiApiKey, 'gemini');
      }
      if (state.pixabayApiKey) {
        await saveEncryptedApiKey(state.pixabayApiKey, 'pixabay');
      }
    } catch (error) {
      console.error('Failed to save API keys:', error);
    }
  }
}));